const blogStyle = {
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  container: {
    paddingTop: "70px",
    paddingBottom: "50px"
  },
  mlAuto: {
    marginLeft: "auto !important"
  },
  mrAuto: {
    marginRight: "auto !important"
  }
};

export default blogStyle;